import React from 'react'
import AnnouncesHome from '../components/announces-home'
import { useTranslation } from 'react-i18next'

function FavoritesPage() {
  const { t } = useTranslation()
  return (
    <div className='pb-5'>
      <div
        id='premium-slider'
        className='text-center mb-5 w-full align-middle bg-redpink text-white  pb-3'
      >
        <p className='uppercase text-2xl'>{t('my-favorites')}</p>
        <p className=''>{t('favorites-desc')}</p>
      </div>
      <AnnouncesHome showOnlyFavorites={true} />
    </div>
  )
}

export default FavoritesPage
